<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>

          <LibraryItems
            rightPanelId="sidebar-add-question-set"
            organizationScopedState="organizationSurveyTemplate"
            libraryScopedState="questionSet"
            :hideSaveAs="true"
            :query="query"
          />
        </b-tab>

        <b-tab :active="isEditMode" v-if="isEditMode && Object.keys(copingEntity).length > 0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("question-set.add-as") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('question-set.text')"
            :label="$t('question-set.text')"
          />

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>

      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("question-set.add-as") }}</span>
        </h2>

        <sweet-input
          inputClass="text-dark"
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('question-set.name')"
          :label="$t('question-set.name')"
        />

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
      </div>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";

import { maxLength, minLength, required } from "vuelidate/lib/validators";
const state = "organizationSurveyTemplate";

export default {
  props: ["hide-library", "product"],
  components: {
    LibraryItems,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
      libraryItem: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
  },
  computed: {
    query() {
      const and = [];
      const organization = this.currentOrganization;

      const sectors = [{ sector: null }];

      if (organization.sector) {
        sectors.push({ sector: { _id: organization.sector._id } });
      }

      and.push({
        $or: sectors,
      });

      const products = [{ products: null }];

      if (this.product) {
        products.push({ products: this.product });
      }

      and.push({
        $or: products,
      });

      return { $and: and };
    },
    isUpdating() {
      return this.$store.getters["organizationQuestionSet/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationQuestionSet/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationQuestionSet/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationQuestionSet/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationQuestionSet/isCoping"];
    },
  },
  mounted() {},
  methods: {
    navigateInsteadAddFromLibrary(libraryItem) {
      // this.$store.dispatch("organizationSurveyTemplate/addFromLibrary", { libraryItem, product: this.libraryItem.products });
      // this.$router.push(`/${this.currentProduct.toLowerCase()}/survey-template`);
    },

    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("organizationQuestionSet/addFromLibrary", {
          libraryItem: {
            ...this.libraryItem,
            name: {
              [this.currentLanguage]: this.form.name,
            },
          },
          product: this.product,
        });
        this.form = {};
        this.cancel();

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.dispatch("organizationQuestionSet/resetForm");
    },
    rightPanelClosed() {
      this.$emit("rightPanelClosed");
    },
    interceptForSetParent(item) {
      this.libraryItem = item;
      item.product = this.product;
    },
  },
};
</script>
